/**
 * Одна ответственность: маппинг кода локали → BCP 47 для og:locale / hreflang.
 */

const LOCALE_TO_BCP47: Record<string, string> = {
  en: 'en-US',
  uk: 'uk-UA',
  ru: 'ru-RU',
  bg: 'bg-BG',
  de: 'de-DE',
  fr: 'fr-FR',
  es: 'es-ES',
  pt: 'pt-PT',
  pl: 'pl-PL',
  it: 'it-IT',
  fi: 'fi-FI',
  lt: 'lt-LT',
  lv: 'lv-LV',
  ro: 'ro-RO',
  hy: 'hy-AM',
  sq: 'sq-AL',
  hr: 'hr-HR',
  sr: 'sr-RS',
  bs: 'bs-BA',
  id: 'id-ID',
  ms: 'ms-MY',
  th: 'th-TH',
  hi: 'hi-IN',
  bn: 'bn-BD',
  ta: 'ta-IN',
  te: 'te-IN',
  mr: 'mr-IN',
  ml: 'ml-IN',
  af: 'af-ZA',
  az: 'az-AZ',
  ge: 'ka-GE',
  ht: 'ht-HT',
}

export function getSeoLangCode(locale: string): string {
  return LOCALE_TO_BCP47[locale] ?? `${locale}-${locale.toUpperCase()}`
}
